// TODO - Add constants

export const recoverPasswordURL = `/api/mobile/v1/users/recoverPassword`;
export const resetPasswordURL = `/api/mobile/v1/users/resetPassword`;
export const strongPasswordRulesURL = `/api/users/rules/password`;
